import React, {forwardRef} from "react";
import {StyledButton} from "./StyledButton";
import "./square-button.css";

export const SquareButton = forwardRef((props, ref) => (
    <StyledButton ref={ref} {...props} className={`square-button ${props.className ? props.className : ""}`} />
));
